import { fabric } from "fabric"
import {OUTLINE_PREFIX_ID} from "../../constants/templates-field-prefixes";


export default class Outline {
  templateData = null
  templateField = null
  inputData = null
  object = null
  id = null

  constructor(templateField, inputData, templateData) {
    this.templateField = templateField
    this.inputData = inputData
    this.templateData = templateData
    this.id = inputData.getId()
  }

  async _initObject() {
    this.object = await new Promise((resolve) => {
      fabric.Image.fromURL(this.inputData.getUrl(), (oImg) => {
        resolve(oImg)
      })
    })
  }
  
  getId() {
    return this.id
  }
  
  getObjectId() {
    return OUTLINE_PREFIX_ID + this.id
  }
  
  getCoordinate() {
    const left = this.inputData.get('x', this.templateField.getLeft());
    const top = this.inputData.get('y', this.templateField.getTop());

    return { left, top }
  }
  
  getScale() {
    let ratio = 1;

    if (this.object.height >= this.object.width) {
        ratio = this.templateField.getHeight() / this.object.height;
    } else if (this.object.height <= this.object.width) {
        ratio = this.templateField.getWidth() / this.object.width;
    }
      
    return {
        scaleX: this.inputData.get('scaleX', ratio),
        scaleY: this.inputData.get('scaleY', ratio)
    }
  }
  
  getConfig() {
    const { left, top } = this.getCoordinate();
    const { scaleX, scaleY } = this.getScale();

    let config = {
        id: this.getObjectId(),
        element_id: this.getObjectId(),
        inputDataId: this.id,
        order: this.templateField.getOrder(),
        templateField: this.templateField,
        left,
        top,
        originX: "left",
        originY: "top",
        scaleX,
        scaleY,
        selectable: this.templateField.isMoveable(),
        evented: this.templateField.isMoveable(),
        real_id: this.templateField.getId(),
        angle: this.inputData.get('angle', 0),
        groupName: this.templateField.getGroupName(),
        color: this.inputData.getColor(),
      };
  
    return config
  }
  
  async render() {
    await this._initObject()
        
    const config = this.getConfig()
  
    this.object.set(config)
    this.object.setControlsVisibility({
      tr: true,
      br: true,
      bl: true,
      ml: false,
      mt: false,
      mr: false,
      mb: false,
      mtr: true,
    });
  
    return this.object
  }
  
  update() {
    if (!this.object) return
    this.object.set(this.getConfig())
  }
  
  removeObjects(canvas) {
    canvas.remove(this.object)
  
    return this
  }
}